"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = require("@/api/college/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {},
  data: function data() {
    return {
      majorList: [{
        majorName: '全部'
      }, {
        majorName: '农林牧渔'
      }, {
        majorName: '装备制造'
      }, {
        majorName: '电子与信息'
      }, {
        majorName: '资源环境与安全'
      }, {
        majorName: '能源动力与材料'
      }, {
        majorName: '生物与化工'
      }, {
        majorName: '交通运输'
      }, {
        majorName: '财经商贸'
      }, {
        majorName: '土木建筑'
      }, {
        majorName: '水利'
      }, {
        majorName: '轻工纺织'
      }, {
        majorName: '食品药品与粮食'
      }, {
        majorName: '医药卫生'
      }, {
        majorName: '旅游'
      }, {
        majorName: '文化艺术'
      }, {
        majorName: '新闻传播'
      }, {
        majorName: '教育与体育'
      }, {
        majorName: '公安与司法'
      }, {
        majorName: '公共管理与服务'
      }, {
        majorName: '公共基础与通识教育'
      }],
      searchForm: {
        majorName: '',
        courseName: ''
      }
    };
  },
  created: function created() {
    // this.getcategoriesList()
  },
  methods: {
    //专业大类
    getcategoriesList: function getcategoriesList() {
      var _this = this;
      (0, _index.categoriesList)({
        pageNum: 1,
        pageSize: 99999,
        provinceId: this.$store.getters.provinceId
      }).then(function (res) {
        if (res.code === 2000) {
          _this.majorList = res.data.list;
        }
      });
    },
    handleSearch: function handleSearch() {
      console.log('searchForm', this.searchForm);
      this.$emit('toSsearch', this.searchForm);
    }
  }
};